import { $list, $user, $view } from 'signals/global.signals';
import { Col, Row } from 'react-bootstrap';
import PageTitle from 'components/global/PageTitle/PageTitle';
import DashboardNotifications from 'components/global/DashboardNotifications';
import Loadable from 'components/global/Loadable';
import useEffectAsync from 'utils/useEffectAsync';
import { fetchAndSetFounderNotifications } from 'components/views/FounderDashboard/_helpers/founderDashboard.resolvers';
import { handleClickDismissFounderNotification } from 'components/views/FounderDashboard/_helpers/founderDashboard.events';
import withDismount from 'hocs/withDismount';

const FounderDashboard = () => {
  useEffectAsync(fetchAndSetFounderNotifications);
  return (
    <Loadable signal={$view}>
      <PageTitle>
        Welcome, {$user.value.firstName}
      </PageTitle>
      <Row>
        <Col xs={12} lg={8}>
          <DashboardNotifications data={$list.value?.data || []} onDismiss={handleClickDismissFounderNotification} />
        </Col>
      </Row>
    </Loadable>
  );
};

export default withDismount(FounderDashboard);
